import { StorageValue } from 'zustand/middleware'
import { chromeStorage } from './storage'

export const createAsyncStorage = <T = any>() => ({
  getItem: async (key: string): Promise<StorageValue<T> | null> => {
    try {
      console.log(`📦 getItem: ${key}`)
      const item = await chromeStorage.get(key)
      if (item) {
        const parsed = JSON.parse(item as string) as StorageValue<T>
        console.log(`✅ getItem success - ${key}:`, parsed)
        return parsed
      }
      console.log(`⚠️ getItem empty - ${key}`)
      return null
    } catch (error) {
      console.error(`❌ Failed to get ${key} from storage:`, error)
      return null
    }
  },
  setItem: async (key: string, value: StorageValue<T>): Promise<void> => {
    try {
      console.log(`💾 setItem: ${key}`, value)
      await chromeStorage.set(key, JSON.stringify(value))
      console.log(`✅ setItem success - ${key}`)
    } catch (error) {
      console.error(`❌ Failed to set ${key} in storage:`, error)
    }
  },
  removeItem: async (key: string): Promise<void> => {
    try {
      console.log(`🗑️ removeItem: ${key}`)
      await chromeStorage.remove(key)
      console.log(`✅ removeItem success - ${key}`)
    } catch (error) {
      console.error(`❌ Failed to remove ${key} from storage:`, error)
    }
  },
})
